import axios from 'axios';
import Cookies from 'js-cookie';
const token = Cookies.get('Token');

const getCredit = async () => {
    const response = await axios.get("/profile", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

const getBanks = async () => {
    const response = await axios.get("https://api.vietqr.io/v2/banks");
    return response.data;
};

const historyRecharge = async () => {
    const token = Cookies.get("Token");

    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/v1/transaction-list`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

const getTotalCredit = async () => {
    const token = Cookies.get("Token");
    if (!token) {
        return null;
    }

    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/v1/credit`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Lỗi khi gọi API getTotalCredit:", error);
        if (error.response && error.response.status === 401) {
            return null;
        }

        throw error;
    }
};



export { getCredit, getBanks, historyRecharge, getTotalCredit };
